type PollOptionsProps = {
    options: { label?: string; percentage?: number }[];
};

export const PollOptions = ({ options }: PollOptionsProps) => (
    <div className="mt-5 flex flex-col space-y-5 text-xs">
        {options.map((option, index) => (
            <div
                key={`poll-option-${index}-${option?.label ?? 'option'}`}
                className="flex items-center justify-between">
                <span>{option?.label}</span>
                {option?.percentage !== undefined && option?.percentage !== null && (
                    <span>{option?.percentage}%</span>
                )}
            </div>
        ))}
    </div>
);
